<app-overlay-loader [show]="isLoading"></app-overlay-loader>
<app-header></app-header>
<div class="main-container d-flex">
  <app-sidebar></app-sidebar>
  <div class="container-fluid h-100p overflow-y-scroll">
    <div class="pricing-container">
      <!-- Title Section -->
      <div class="title-section">
        <h1 class="title">Find Your Perfect Plan</h1>
      </div>

      <!-- Subtitle Section -->
      <div class="subtitle-section">
        <p class="subtitle">
          Explore data at different depths — from surface-level lookups to deep intelligence.
        </p>
      </div>

      <!-- Pricing Cards Grid -->
      <div class="pricing-grid">
        <div *ngFor="let plan of plans" class="pricing-card-wrapper" [class.popular-wrapper]="plan.isPopular">
          <div class="pricing-card" [class.popular]="plan.isPopular">
            <div class="popular-badge" *ngIf="plan.isPopular">Most Popular</div>

            <h2 class="plan-title">{{ plan.title }}</h2>
            <p class="plan-description">{{ plan.description }}</p>

            <div class="plan-price-container">
              <span class="plan-price-amount">{{ plan.price | currency:'INR':'symbol':'1.0-0' }}</span>
              <span class="plan-price-suffix"> + GST</span>
              <span class="plan-price-suffix"> / plan</span>
            </div>

            <ul class="plan-features">
              <li class="plan-feature">
                <i class="bi bi-check-circle-fill checkmark"></i>
                <span>{{ plan.totalCredits || 0 }} total credits</span>
              </li>
              <li class="plan-feature">
                <i class="bi bi-check-circle-fill checkmark"></i>
                <span>Valid for {{ plan.validityPeriod || 0 }} days</span>
              </li>
              <!-- <li class="plan-feature">
                <i class="bi bi-check-circle-fill checkmark"></i>
                <span>Daily usage limit: {{ plan.maxSearchesPerDay || 'Unlimited' }} credits</span>
              </li> -->
            </ul>

            <button class="plan-button" [class]="plan.buttonClass" (click)="selectPlan(plan)"
              [disabled]="processingPlanId !== null || isLoading">
              <span *ngIf="!isPlanProcessing(plan.id)">{{ plan.buttonText }}</span>
              <span *ngIf="isPlanProcessing(plan.id)">
                <i class="bi bi-hourglass-split"></i> Processing...
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Payment Success Modal -->
<div class="payment-success-overlay" *ngIf="showPaymentSuccessModal" (click)="closePaymentSuccessModal()">
  <div class="payment-success-modal" (click)="$event.stopPropagation()">
    <!-- Success Icon -->
    <div class="modal-success-icon-container">
      <div class="modal-success-icon-circle">
        <i class="bi bi-check-lg modal-success-checkmark"></i>
      </div>
    </div>

    <!-- Main Heading -->
    <h1 class="modal-success-heading">
      Your Plan Has been<br />Activated
    </h1>

    <!-- Transaction ID Section -->
    <div class="modal-transaction-section">
      <label class="modal-transaction-label">Transaction ID</label>
      <div class="modal-transaction-input-container">
        <span class="modal-transaction-id">{{ transactionId }}</span>
        <button class="modal-copy-button" (click)="copyTransactionId()" type="button">
          <i class="bi bi-files"></i>
        </button>
      </div>
    </div>

    <!-- Invoice Actions -->
    <div class="modal-invoice-actions">
      <button
        type="button"
        class="modal-invoice-btn"
        (click)="onViewInvoice()"
        [disabled]="isInvoiceBusy || !transactionId">
        <i class="bi bi-eye"></i>
        {{ isInvoiceBusy ? 'Preparing...' : 'View Invoice' }}
      </button>
      <button
        type="button"
        class="modal-invoice-btn modal-invoice-btn-primary"
        (click)="onDownloadInvoice()"
        [disabled]="isInvoiceBusy || !transactionId">
        <i class="bi bi-download"></i>
        Download Invoice
      </button>
    </div>

    <!-- Back to Home Button -->
    <button class="modal-back-to-home-btn" (click)="backToHome()">
      Back to Home
      <i class="bi bi-arrow-right"></i>
    </button>
  </div>
</div>

<app-billing-details-dialog
  *ngIf="showBillingModal"
  [existingDetails]="billingDetails"
  [title]="billingDialogTitle"
  [subtitle]="billingDialogSubtitle"
  (saved)="onBillingDetailsSaved($event)"
  (closed)="closeBillingModal()">
</app-billing-details-dialog>